import classNames from 'classnames'
import { ReactNode } from 'react'

const DisabledWrapper = (children: ReactNode) => (
  <div className={classNames('c-input__wrapper--disabled')}>{children}</div>
)

export default DisabledWrapper
